<template>
	<system v-if="isOpen" class="system system--lock"></system>
</template>

<script>
import { uiComponents } from '../../tools/viewState';
import UiBase from '../ui/base.vue';
export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.systemLock,
		};
	},
};
</script>
